module.exports = __webpack_public_path__ + "4578cacfb766150b7e1956ecff004e22.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/guitar/3_D2.mp3
// module id = 78
// module chunks = 0